export default __webpack_public_path__ + "static/media/20.d311a526.png";